export type TAnimation = Readonly<Record<'duration', number>>;

export const DEFAULT_ANIMATION = {
  duration: 400,
} as const satisfies TAnimation;

export const createAnimation = <TCustomAnimation extends TAnimation = typeof DEFAULT_ANIMATION>(
  customAnimation?: TCustomAnimation,
) => (customAnimation ?? DEFAULT_ANIMATION) as TCustomAnimation;
